import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Main from '@/app/components/styles/Main/Main';
import Page from '@/app/components/Page';
import useIsPermitted from '@/app/utils/hooks/useIsPermitted';
import { catchPhrase } from '@/app/components/config/config';
import { PERMISSION_TYPES } from '@/app/utils/isPermitted';
import ActivityTextSchedule from './ActivityTextSchedule';
import MassTexting from './MassTexting';
import Link2Text from './Link2Text';

const propTypes = {};
const defaultProps = {};

function PatientMessaging() {
    // flag to if the user has permission to access patient messaging activity text schedule
    const hasEnabledActivityTextSchedule = useIsPermitted(PERMISSION_TYPES.ACTIVITY_TEXT_SCHEDULE);
    // flag to if the user has permission to access patient messaging activity text schedule
    const hasEnabledMassTexting = useIsPermitted(PERMISSION_TYPES.MASS_TEXTING);
    // flag to if the user (Company Admin + GENERATE_MOBILE_LINK) can access the Link2Text tab
    const hasEnabledLink2Text = useIsPermitted(PERMISSION_TYPES.LINK_2_TEXT);

    let defaultActiveKey = 'link2text';
    if (hasEnabledMassTexting) {
        defaultActiveKey = 'mass-texting';
    } else if (hasEnabledActivityTextSchedule) {
        defaultActiveKey = 'activity_text_schedule';
    }

    return (
        <Main>
            <Helmet>
                <title>Patient Messaging - {catchPhrase}</title>
            </Helmet>
            <Page title="Patient Messaging" permissionType={PERMISSION_TYPES.PATIENT_MESSAGING} showPageTitle>
                <Tabs defaultActiveKey={defaultActiveKey} id="patient-messaging">
                    {hasEnabledMassTexting && (
                        <Tab eventKey="mass-texting" title="Mass Texting">
                            <MassTexting />
                        </Tab>
                    )}
                    {hasEnabledActivityTextSchedule && (
                        <Tab eventKey="activity_text_schedule" title="Activity Text Schedule">
                            <ActivityTextSchedule />
                        </Tab>
                    )}
                    {hasEnabledLink2Text && (
                        <Tab eventKey="link2text" title="Link2Text">
                            <Link2Text />
                        </Tab>
                    )}
                </Tabs>
            </Page>
        </Main>
    );
}

PatientMessaging.prototype = propTypes;
PatientMessaging.defaultProps = defaultProps;

export default PatientMessaging;
